import React from 'react'
import './Kisan.css'
const Kisan=()=>{
    return(
        <>
        <br/>
        <br/>
        <br/>
        <br/>
        <div className='content'>
            <div className='option'>
                <h3>PM Kisan Helpline</h3>
                
                <h5>
                <a       href="tel:1800-180-1551">Click to call</a></h5>
            </div>
            <div className='option'>
                <h3>JNKVV Jabalpur</h3>
                
                <h5>
                <a       href="tel:07612681236">Click to call</a></h5>
            </div>
            <div className='option'>
                <h3>Krishi Kalyan Krushi Vikas Vibahg</h3>
                
                <h5>
                <a       href="tel:09425701987">Click to call</a></h5>
            </div>
            <div className='option'>
                <h3>Krishi Upaj Mandi Jabalpur</h3>
                
                <h5>
                <a       href="tel:07614031091">Click to call</a></h5>
            </div><div className='option'>
                <h3>Gujrat Krishi Helpline number</h3>
                
                <h5>
                <a       href="tel:07923250802">Click to call</a></h5>
            </div>
            <div className='option'>
                <h3>Chattisgarh Krishi Helpline number</h3>
                
                <h5>
                <a       href="tel:18002333663">Click to call</a></h5>
            </div>
            <div className='option'>
                <h3>Chattisgarh Krishi Helpline number</h3>
                
                <h5>
                <a       href="tel:18002333663">Click to call</a></h5>
            </div>
            <div className='option'>
                <h3>Haryana Krishi Helpline number</h3>
                
                <h5>
                <a       href="tel:01722571553">Click to call</a></h5>
            </div>
            <div className='option'>
                <h3>Krishi Vigayn Kendra,Delhi</h3>
                
                <h5>
                <a       href="tel:18002333663">Click to call</a></h5>
            </div>
            <div className='option'>
                <h3>Rajmata Vijayrajay Scindhia Krishi Vishwavidayala</h3>
                
                <h5>
                <a       href="tel:07512467673">Click to call</a></h5>
            </div>
            <div className='option'>
                <h3>Krishi Upaj Mandi Indore</h3>
                
                <h5>
                <a       href="tel:7312762558">Click to call</a></h5>
            </div>
        </div>
        </>

    )
}
export default Kisan